import React, { useState } from "react";
import "../assets/scss/register.scss";
import { Col, Input, Label, Row } from "reactstrap";
import { Link } from "react-router-dom";
import PasswordInput from "../components/PasswordInput";
import { useApi } from "../hooks/useApi";
import { useDispatch } from "react-redux";
import { handleLogin } from "../store/user";
import { toast } from "react-toastify";

const Login = () => {
  const [values,setValues] = useState({email:"",password:""})
  const dispatch = useDispatch()
  const handleSubmit = (e) => {
      e.preventDefault();
      document.querySelectorAll(".register-input").forEach((input)=> {
        if(input.value === ""){
          input.classList.add("is-invalid")
        }
      })
      const formData = new FormData()
      for (const key in values) {
        formData.append(key,values[key])
      }
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useApi().post("account/login",formData).then((res)=>{
        if(res.data.status){
          dispatch(handleLogin(res.data.token))
        }else{
          toast.error("Şu anda giriş yapılamıyor, lütfen daha sonra tekrar deneyiniz.",{
            position:'top-center'
          })
        }
      }).catch((err) => {
        console.log("Şu anda giriş yapılamıyor, lütfen daha sonra tekrar deneyiniz.")
      })
  }
  return (
    <div className="wrapper">
      <div className="left-side d-flex align-items-center justify-content-center">
        <div className="d-flex flex-column h-100 position-relative" style={{zIndex:2}}>
          <Link to="/" className="mx-auto mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="205"
              height="45"
              viewBox="0 0 205 45"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M98.0644 0C98.3406 0 98.5644 0.223858 98.5644 0.5V32.0699C98.5644 32.3461 98.3406 32.5699 98.0644 32.5699H94.8163C94.5402 32.5699 94.3163 32.3461 94.3163 32.0699V31.4261C94.3163 30.964 93.7182 30.7278 93.3625 31.0228C91.9364 32.2053 90.0839 32.924 87.9439 32.924C82.4567 32.924 78.0312 28.3218 78.0312 22.6576C78.0312 16.9934 82.4564 12.3912 87.9439 12.3912C90.0839 12.3912 91.9364 13.1099 93.3625 14.2924C93.7182 14.5874 94.3163 14.3512 94.3163 13.8891V0.5C94.3163 0.223858 94.5402 0 94.8163 0H98.0644ZM94.316 22.6573C94.316 19.1612 91.7052 16.2848 88.2976 16.2848C84.8901 16.2848 82.2793 19.1612 82.2793 22.6573C82.2793 26.1533 84.8901 29.0297 88.2976 29.0297C91.7052 29.0297 94.316 26.1533 94.316 22.6573ZM70.1454 27.1174C70.3676 26.9161 70.7164 26.9361 70.9016 27.1718L72.7165 29.4815C72.8715 29.6787 72.8573 29.9613 72.6745 30.1331C70.8414 31.8566 68.3599 32.9237 65.6414 32.9237C59.9772 32.9237 55.375 28.3215 55.375 22.6572C55.375 16.993 59.9772 12.3908 65.6414 12.3908C69.9395 12.3908 73.194 14.9373 74.3913 19.0167C74.4544 19.2319 74.3579 19.4604 74.1638 19.5728L61.8302 26.7155C61.5731 26.8644 61.5014 27.2049 61.7101 27.4164C62.6357 28.3543 64.1722 29.0297 65.6414 29.0297C67.4999 29.0297 68.9698 28.1818 70.1454 27.1174ZM59.6228 22.6572C59.6228 23.0211 59.6596 23.3482 59.6998 23.7057C59.7052 23.7539 59.7583 23.7807 59.8003 23.7565L69.0466 18.4254C69.3065 18.2755 69.3789 17.93 69.1747 17.7102C68.4856 16.9681 67.4204 16.2848 65.6411 16.2848C62.3665 16.2848 59.6228 19.3826 59.6228 22.6572ZM105.082 12.7445C104.806 12.7445 104.582 12.9683 104.582 13.2445V23.188C104.582 29.4719 107.414 32.9236 112.459 32.9236C114.292 32.9236 115.736 32.3313 116.728 31.5758C117.133 31.268 118.035 31.5762 118.035 32.0844C118.035 32.3523 118.252 32.5694 118.52 32.5694H121.783C122.059 32.5694 122.283 32.3456 122.283 32.0694V13.2441C122.283 12.968 122.059 12.7441 121.783 12.7441H118.535C118.258 12.7441 118.035 12.968 118.035 13.2441V22.6568C118.035 26.6396 115.822 29.0293 113.255 29.0293C109.981 29.0293 108.83 26.9496 108.83 23.5421V13.2445C108.83 12.9683 108.606 12.7445 108.33 12.7445H105.082ZM126.862 13.4559C126.708 13.1245 126.95 12.7449 127.316 12.7449H130.811C131.007 12.7449 131.186 12.86 131.266 13.0391L135.634 22.7106C135.811 23.1029 136.368 23.1029 136.546 22.7106L140.913 13.0391C140.994 12.86 141.173 12.7449 141.369 12.7449H144.864C145.23 12.7449 145.472 13.1245 145.317 13.4559L136.543 32.3044C136.364 32.6897 135.816 32.6897 135.637 32.3044L126.862 13.4559ZM165.073 30.1329C165.256 29.9611 165.27 29.6785 165.115 29.4813L163.3 27.1716C163.115 26.9359 162.766 26.916 162.544 27.1172C161.368 28.1817 159.898 29.0295 158.04 29.0295C156.571 29.0295 155.034 28.3541 154.109 27.4162C153.9 27.2047 153.971 26.8642 154.229 26.7153L166.562 19.5726C166.756 19.4602 166.853 19.2317 166.79 19.0165C165.592 14.9371 162.338 12.3906 158.04 12.3906C152.376 12.3906 147.773 16.9928 147.773 22.6571C147.773 28.3213 152.376 32.9235 158.04 32.9235C160.758 32.9235 163.24 31.8565 165.073 30.1329ZM152.099 23.7055L152.099 23.7052L152.098 23.7047C152.058 23.3475 152.021 23.0207 152.021 22.6571C152.021 19.3825 154.765 16.2846 158.04 16.2846C159.819 16.2846 160.884 16.968 161.573 17.71C161.778 17.9298 161.705 18.2754 161.445 18.4252L152.199 23.7563C152.157 23.7805 152.104 23.7537 152.099 23.7055ZM181.966 12.3988C182.242 12.3896 182.467 12.6145 182.467 12.8906V16.2895C182.467 16.6066 182.176 16.8422 181.861 16.8013C180.958 16.6835 179.971 16.721 178.927 17.0814C176.183 18.0549 175.387 20.666 175.387 23.675V32.0697C175.387 32.3459 175.163 32.5697 174.887 32.5697H171.639C171.362 32.5697 171.139 32.3459 171.139 32.0697V13.2447C171.139 12.9686 171.362 12.7447 171.639 12.7447H174.887C175.163 12.7447 175.387 12.9686 175.387 13.2447V13.9956C175.387 14.5089 176.161 14.7454 176.527 14.3855C177.765 13.1679 179.512 12.4801 181.966 12.3988ZM192.44 43.191C192.644 43.191 192.827 43.0675 192.904 42.8789L204.844 13.433C204.978 13.1043 204.736 12.7451 204.381 12.7451H200.862C200.657 12.7451 200.472 12.871 200.397 13.0623L195.717 24.9784C195.551 25.4001 194.955 25.4018 194.787 24.9811L190.027 13.0597C189.951 12.8697 189.767 12.7451 189.562 12.7451H186.049C185.692 12.7451 185.45 13.1082 185.588 13.4376L193.008 31.2291C193.058 31.3513 193.059 31.4887 193.009 31.6111L188.546 42.5014C188.411 42.8304 188.653 43.191 189.009 43.191H192.44Z"
                fill="#36313D"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.9507 44.3218C34.0073 44.3218 43.7808 34.5483 43.7808 22.4923C43.7808 10.4356 34.0068 0.662109 21.9507 0.662109C9.8946 0.662109 0.121094 10.4356 0.121094 22.4923C0.121094 24.2903 0.338352 26.0376 0.748235 27.7092C1.19059 29.5132 3.2685 30.203 4.87708 29.2742C6.1592 28.5339 6.70574 26.9922 6.44105 25.5355C6.26162 24.5481 6.16789 23.531 6.16789 22.4923C6.16789 13.1391 13.7669 5.54004 23.1201 5.54004C28.3406 5.54004 32.6288 7.81544 35.3174 11.6994C37.3148 14.5833 35.6347 18.3003 32.599 20.0585L20.1342 27.2775C17.9428 28.5465 17.4677 31.4768 19.8332 32.3807C20.8808 32.7811 22.0121 33.0137 23.1201 33.0137C25.136 33.0137 26.8751 32.4094 28.3816 31.4962C30.0459 30.4875 32.2887 30.5611 33.4911 32.0914C34.4974 33.3721 34.4162 35.2304 33.1001 36.1899C30.3018 38.23 26.8459 39.4439 23.1201 39.4439C18.698 39.4439 14.6678 37.7454 11.6476 34.9657C10.5953 33.9972 9.03763 33.684 7.79903 34.399C6.25803 35.2886 5.8641 37.3551 7.17347 38.5599C11.0614 42.1374 16.251 44.3218 21.9507 44.3218ZM13.3298 24.3915L16.8568 22.3577L29.5505 15.0384L29.5456 15.0317C28.4495 13.5722 26.6226 11.9697 23.1209 11.9697C17.7135 11.9697 13.1836 17.0843 13.1836 22.4918C13.1836 23.0926 13.2444 23.6326 13.3108 24.2229C13.3171 24.2786 13.3234 24.3348 13.3298 24.3915Z"
                fill="#36313D"
              />
            </svg>
          </Link>
          <h4 className="text-center">Hemen Başla</h4>
          <p className="text-center">
            Hesabınıza erişebilmek için bilgilerinizi girin
          </p>
          {/* <div className="d-flex gap-3 justify-content-center mb-4">
            <button className="btn btn-outline-dark">
              <div className="d-flex align-items-center gap-2">
                <img
                  src="./images/logos/google.png"
                  alt="eduvery google login"
                />
                Google ile giriş yap
              </div>
            </button>
            <button className="btn btn-outline-dark">
              <div className="d-flex align-items-center gap-2">
                <img
                  src="./images/logos/facebook.png"
                  alt="eduvery facebook login"
                />
                Facebook ile giriş yap
              </div>
            </button>
            <button className="btn btn-outline-dark">
              <div className="d-flex align-items-center gap-2">
                <img src="./images/logos/apple.png" alt="eduvery apple login" />
                Apple ile giriş yap
              </div>
            </button>
          </div>
          <div className="d-flex align-items-center gap-4 mb-4">
            <hr className="col" />
            <span> ya da</span>
            <hr className="col" />
          </div> */}
          <Row tag={"form"} onSubmit={handleSubmit}>
            
            <Col xs="12" className="mb-2">
              <Label htmlFor="email" className="register-label">
                Email
              </Label>
              <Input id="email" className="register-input" type="email" value={values.email} onChange={(e) => setValues(values => ({...values,email:e.target.value}))}/>
            </Col>
            <Col xs="12" className="mb-2">
            <Label className="register-label">Şifre</Label>
              <PasswordInput value={values.password} onChange={(e) => setValues(values => ({...values,password:e.target.value}))} />
              <div className="d-flex mt-1">
              <Link to="/forget-password" className="ms-auto link-button ">
              Şifremi Unuttum
            </Link>
              </div>
            </Col>
            <div className="d-flex justify-content-center mt-4">
            <button className="btn btn-dark btn-lg" type="submit">Giriş Yap</button>
          </div>
          </Row>
          
          <div className="d-flex justify-content-center mt-3 link-wrapper">
            Hesabın yok mu ?{" "}
            <Link to="/register" className="ms-1 link-button">
              Kayıt Ol
            </Link>
          </div>
        </div>
      </div>
      <div className="right-side ">
        <div className="right-side-text">
          <p className="main-text mb-0">
            <span className="text-line">Geleceğin formülü:</span><br />
            <span className="fw-medium">Eduvery!</span>{" "}
          </p>
          <p className="main-text"> Kendini test et, <br /> yönünü belirle! </p>
        </div>
      </div>
      <div className="absolute-image">
        <img src="./images/hero.png"   alt="" />
      </div>
    </div>
  );
};

export default Login;
